import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import DistAPI from '../../../api/DistributionAPI';
import Condition from './Condition';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';
import DistributionUtil from './DistributionUtil';
import ApiUiController from '../../../controller/ApiUiController';
import RegEx from '../../../util/RegEx';
import Display from '../../../util/Display';

import '../Settings.css';

class LeadDistributionUpdate extends React.Component {

  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);
    this.state = {
      inApiCall: this.id !== 0, name: '', condition: Const.AND,
      id: id, users: [null], action: 1, assign_to: '', priority: '', inValid: {}
    };
    const model = reactLocalStorage.getObject(Const.Model);
    this.model = model.lead;
    this.fields = FieldController.getFilterFields(this.model.fields);
    this.users = model.user.options;

    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf('/'));
    this.conditions = [{}];
  }

  componentDidMount() {
    if (this.state.id !== 0) { DistAPI.get(this.state.id, this.onReceived, this.onFail); }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = dist => {
    const users = [];
    dist.assign_to = dist.assign_to && dist.assign_to.length > 2
      ? dist.assign_to.substring(1, dist.assign_to.length - 1).split(Const.Opt).map(user => parseInt(user))
      : [];
    for (let i = 0; i < dist.assign_to.length; i++) {
      users.push(this.users.find(usr => dist.assign_to[i] === usr.value));
    }
    this.conditions = JSON.parse(dist.conditions);

    this.setState({
      ...this.state, id: dist.id, name: dist.name,
      users: users && users.length > 0 ? users : [null],
      condition: dist.condition_option, action: dist.action,
      assign_to: dist.assign_to, priority: dist.priority
    });
  };

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  priorityChange = event => this.setState({ ...this.state, priority: event.target.value });
  toggleChange = tog => this.setState({ ...this.state, condition: tog });
  usersChange = (i, selected) => {
    const users = [...this.state.users];
    users[i] = selected;
    this.setState({ ...this.state, users: [...users] });
  };
  add = () => {
    const users = [...this.state.users];
    users.push(null);
    this.setState({ ...this.state, users: [...users] });
  };
  delete = index => {
    let users = [...this.state.users];
    users = users.filter((_, i) => i !== index);
    this.setState({ ...this.state, users: [...users] });
  };
  edit = conditions => this.conditions = conditions;

  onSave = () => {
    let inValid = {};
    if (this.state.name.trim() === '') inValid = { ...inValid, name: 'Invalid Field' };
    if (this.state.priority === '') inValid = { ...inValid, priority: 'Invalid Field' };
    if (this.conditions.length === 0) inValid = { ...inValid, conditions: 'Invalid Field' };
    if (this.state.users.filter(item => !!item).length === 0) inValid = { ...inValid, assign_to: 'Invalid Field' };

    if (Object.keys(inValid).length === 0) {
      this.setState({ ...this.state, inApiCall: true });
      let conditions = this.conditions.map(filter => {
        if (Object.keys(filter).length === 0) return {};
        else return {
          field: filter.field.value,
          type: filter.field.type, condition: filter.condition.value, value: filter.value
        };
      });

      const assign_to = Const.Opt + this.state.users.filter(item => !!item).map(item => item.id).join(Const.Opt) + Const.Opt;
      conditions = JSON.stringify(conditions);
      const dist = {
        id: this.state.id, name: this.state.name, assign_to,
        condition_option: this.state.condition, priority: this.state.priority, action: this.state.action, conditions
      };
      DistAPI.save(dist, this.onSaved, this.onFail);
    } else {
      Util.showNotification('Form incomplete', 'Please fill all information', 'danger');
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };

  render() {
    const inValid = this.state.inValid;
    const assignments = this.state.users.map((user, i) =>
      <div key={`user_${i}`} className="col-md-12 condition-select-div">
        <div className="col-md-4">
          <Select value={user} onChange={selected => this.usersChange(i, selected)}
            options={this.users} isSearchable={true} isMulti={false}
            className={`mr-sm-2 assignselect ${RegEx.class(inValid, 'assign_to')}`} />
        </div>
        {Display.MultiAction(i, this.add, this.delete)}
      </div>
    );
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12 pb-3"><h3>Lead Distribution</h3></div>
          </div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Distribution Name'
                    className={`mr-sm-2 ${RegEx.class(inValid, 'name')}`}
                    value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Distribution Priority'
                    className="mr-sm-2" value={this.state.priority} onChange={this.priorityChange} />
                </div>
              </div>

              <div className="col-md-4">
                <label>Conditional Option</label>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.condition === Const.AND}
                    onChange={() => this.toggleChange(Const.AND)} />
                  <Form.Check.Label>AND</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.condition === Const.OR}
                    onChange={() => this.toggleChange(Const.OR)} />
                  <Form.Check.Label>OR</Form.Check.Label>
                </Form.Check>
              </div>

              <div className="formhead col-md-12"><h4>Action</h4></div>
              <Select value={DistributionUtil.Options.find(opt => opt.value === this.state.action)}
                onChange={selected => this.setState({ ...this.state, action: selected.value })}
                options={DistributionUtil.Options} isSearchable={true} isClearable={false} />

              <div className="formhead col-md-12"><h4>Condition</h4></div>
              <Condition model={this.model} fields={this.fields} value={this.conditions}
                eKey="conditions" onConditionChanged={this.edit} />

              <div className="formhead col-md-12"><h4>Assign To</h4></div>
              {assignments}

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(LeadDistributionUpdate);